import React from 'react';
import styled from 'App/styled';
import { useTheme } from 'emotion-theming';

import { SearchSuggestion } from 'types/searchSuggestion';
import ProductSuggestion from './ProductSuggestion';
import OtherSuggestion from './OtherSuggestion';

interface SuggestionsProps {
  suggestions: SearchSuggestion[];
  handleClick: (suggestion: SearchSuggestion, position: number) => void;
  searchField?: string;
  isOfTypeProduct?: boolean;
  title?: string;
}

const Wrapper = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;

  h4 {
    padding: 0;
    margin: 15px;
    ${({ theme }) => theme.typography.subTitleMedium};
  }
`;

function Suggestions({
  suggestions,
  handleClick,
  searchField = '',
  isOfTypeProduct = false,
  title,
}: SuggestionsProps) {
  const theme: Theme = useTheme();
  if (!suggestions || !(suggestions.length > 0)) {
    return null;
  }

  const clickHandler = (suggestion: SearchSuggestion, position: number) => {
    // TODO: append params to URL
    handleClick(suggestion, position);
  };

  return (
    <Wrapper textColor={theme.darkGrey}>
      {title && <h4>{title}</h4>}
      {suggestions.map((suggestion, index) => {
        let { q } = suggestion;
        if (isOfTypeProduct) {
          return (
            <ProductSuggestion
              key={q}
              handleClick={clickHandler}
              index={index}
              searchField={searchField}
              suggestion={suggestion}
            />
          );
        }
        return (
          <OtherSuggestion
            key={q}
            handleClick={clickHandler}
            index={index}
            searchField={searchField}
            suggestion={suggestion}
          />
        );
      })}
    </Wrapper>
  );
}

export default Suggestions;
